module.exports = __webpack_public_path__ + "img/oth15.9b5c6102.png";